/**
 * @module:  导出页面
 * @author Liang Huang
 * @date 2020-10-14 09:36:05
 */
import { lazy } from 'react';
import { retry } from '@src/utils/tool';

// 我的任务页面
export const MyTask = lazy(() => retry(() => import('@Company/Task/MyTask/index')));
// 新建任务页面
export const TaskCreate = lazy(() => retry(() => import('@Company/Task/TaskCreate')));
// 任务详情
export const TaskDetail = lazy(() => retry(() => import('@Company/Task/TaskDetail')));

// 任务描述页面
export const Descript = lazy(() => retry(() => import('@Company/Task/Descript')));
// 项目列表页面
export const ProjectList = lazy(() => retry(() => import('@Company/ProjectList')));
export const ProjectDetail = lazy(() => retry(() => import('@Company/ProjectDetail')));
// 新建项目页面
export const ProjectCreate = lazy(() => retry(() => import('@Company/ProjectCreate')));
// 企业认证页面
export const AuthCompany = lazy(() => retry(() => import('@Company/AuthCompany')));
// 注册协议
export const Privacy = lazy(() => retry(() => import('@Company/Legal/privacy')));
// 用户协议
export const Legal = lazy(() => retry(() => import('@Company/Legal/legal')));

// App-用户协议
export const AppLegal = lazy(() => retry(() => import('@Company/Legal/applegal')));
// App-用户隐私协议
export const AppPrivacy = lazy(() => retry(() => import('@Company/Legal/appprivacy')));
// 职位发布规则
export const PositionLegal = lazy(() => retry(() => import('@Company/Legal/positionlegal')));
// 独立入口
export const ProjectHome = lazy(() => retry(() => import('@Company/Home/index')));
// 工作台说明页
export const WorkbenchIntro = lazy(() => retry(() => import('@Company/WorkbenchIntro')));
// 文件预览
export const FilePreview = lazy(() => retry(() => import('@Company/FilePreview')));
// 升级提示
export const UpgradeTips = lazy(() => retry(() => import('@Company/UpgradeTips')));
// 蚂蚁链认证
export const AntPay = lazy(() => retry(() => import('@Company/AntPay')));
// 蚂蚁链认证结果
export const AntPayResult = lazy(() => retry(() => import('@Company/AntPay/result')));
// 个人实名认证
export const PersonalVerify = lazy(() => retry(() => import('@Company/PersonalVerify')));
// app 应用宝下载跳板
export const AppDownload = lazy(() => retry(() => import('@Company/AppDownload')));
